import { ApToggleSwitch } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const TitleWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const Title = styled.div`
	font-weight: 500;
	font-size: 14px;
	color: #000000;
	flex: 1;
	margin: 0.5%;
`;

export const ActionWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const ToggleSwitch = styled(ApToggleSwitch)`
	margin: 2px 0 0 3px;
`;

export const ContentWrapper = styled.div``;
